import ConfirmationDialog, {
  ConfirmationBasePropsType,
} from "./ConfirmationDialog";

export type ConfirmationBaseProps = ConfirmationBasePropsType;

export default ConfirmationDialog;
